/**
 * Custom Select Component
 * Extends Ant Design Select with custom styling
 */

import { Select as AntSelect, SelectProps as AntSelectProps } from 'antd';
import classNames from 'classnames';
import './CustomSelect.scss';

export interface CustomSelectProps extends Omit<AntSelectProps, 'variant'> {
  /** Select variant */
  selectVariant?: 'default' | 'filled' | 'bordered';
  /** Show error state */
  error?: boolean;
  /** Error message */
  errorMessage?: string;
}

/**
 * CustomSelect Component
 */
export const CustomSelect: React.FC<CustomSelectProps> & {
  Option: typeof AntSelect.Option;
} = Object.assign(
  ({
    selectVariant = 'default',
    error = false,
    errorMessage,
    className,
    ...rest
  }: CustomSelectProps) => {
    const selectClasses = classNames(
      'custom-select',
      `custom-select--${selectVariant}`,
      {
        'custom-select--error': error,
      },
      className
    );

    return (
      <div className="custom-select-wrapper">
        <AntSelect {...rest} className={selectClasses} />
        {error && errorMessage && (
          <span className="custom-select__error-message">{errorMessage}</span>
        )}
      </div>
    );
  },
  {
    Option: AntSelect.Option,
  }
);

export default CustomSelect